import { PurchasingRepository } from '@Purchasing/Data/Repository/PurchasingRepository'
import { FinanceSummary, PurchasePayment } from '@Purchasing/Domain/Model/PurchaseProcess'
import {
    CreatePurchasePaymentPayload,
    MarkPaymentPaidPayload,
    UpdatePurchasePaymentPayload,
} from '@Purchasing/Data/DataSource/API/Entity/PurchaseProcess'

export interface GetPurchaseFinance {
    execute(
        processId: string
    ): Promise<{ summary: FinanceSummary; payments: PurchasePayment[] }>
}

export class GetPurchaseFinanceUseCase implements GetPurchaseFinance {
    constructor(private repository: PurchasingRepository) {}
    execute(processId: string) {
        return this.repository.getPurchaseFinance(processId)
    }
}

export interface CreatePurchasePaymentOp {
    execute(
        processId: string,
        payload: CreatePurchasePaymentPayload
    ): Promise<PurchasePayment>
}

export class CreatePurchasePaymentUseCase implements CreatePurchasePaymentOp {
    constructor(private repository: PurchasingRepository) {}
    execute(
        processId: string,
        payload: CreatePurchasePaymentPayload
    ): Promise<PurchasePayment> {
        return this.repository.createPurchasePayment(processId, payload)
    }
}

export interface UpdatePurchasePaymentOp {
    execute(
        processId: string,
        paymentId: string,
        payload: UpdatePurchasePaymentPayload
    ): Promise<PurchasePayment>
}

export class UpdatePurchasePaymentUseCase implements UpdatePurchasePaymentOp {
    constructor(private repository: PurchasingRepository) {}
    execute(
        processId: string,
        paymentId: string,
        payload: UpdatePurchasePaymentPayload
    ): Promise<PurchasePayment> {
        return this.repository.updatePurchasePayment(
            processId,
            paymentId,
            payload
        )
    }
}

export interface MarkPurchasePaymentPaid {
    execute(
        processId: string,
        paymentId: string,
        payload: MarkPaymentPaidPayload
    ): Promise<PurchasePayment>
}

export class MarkPurchasePaymentPaidUseCase
    implements MarkPurchasePaymentPaid
{
    constructor(private repository: PurchasingRepository) {}
    execute(
        processId: string,
        paymentId: string,
        payload: MarkPaymentPaidPayload
    ): Promise<PurchasePayment> {
        return this.repository.markPurchasePaymentPaid(
            processId,
            paymentId,
            payload
        )
    }
}

export interface CancelPurchasePayment {
    execute(processId: string, paymentId: string): Promise<PurchasePayment>
}

export class CancelPurchasePaymentUseCase implements CancelPurchasePayment {
    constructor(private repository: PurchasingRepository) {}
    execute(
        processId: string,
        paymentId: string
    ): Promise<PurchasePayment> {
        return this.repository.cancelPurchasePayment(processId, paymentId)
    }
}
